import { useMemo, useState } from 'react';

import { EntityRef } from '@sayyesschool/common/entities/common';
import PageSection from '@sayyesschool/frontend/components/page-section';

import Tasks from '@/components/tasks/tasks';

export default function TeacherTasks({ teacher }) {
    const [isFormOpen, setFormOpen] = useState(false);

    const entity = useMemo(() => ({
        id: teacher?.id,
        type: EntityRef.Teacher
    }), [teacher?.id]);

    return (
        <PageSection
            title="Задачи"
            actions={[{
                key: 'add',
                icon: 'add',
                onClick: () => setFormOpen(true)
            }]}
            compact
        >
            <Tasks
                entity={entity}
                isFormOpen={isFormOpen}
                setFormOpen={setFormOpen}
            />
        </PageSection>
    );
}